import VueRouter from 'vue-router';
import Quiz from './pages/Quiz';
import Deck from './pages/Deck';
import Pitch from './pages/Pitch';
import Home from "./pages/Home.vue";
import Paying from "./pages/Paying.vue";
import GetYourApp from "./pages/GetYourApp.vue";
import GetYourAppNow from "./pages/GetYourAppNoTrial.vue";
import ApplyToAJob from './pages/ApplyToAJob';
import Applied from './pages/Applied';
import LastStep from './pages/LastStep';
import Sxsw from './pages/Sxsw';
import SxswRegister from './pages/SxswRegister';
import Bot from './pages/Bot';
import RequestBot from "./pages/RequestBot";

const router = new VueRouter({
  mode: 'history',
  routes: [
    { name: 'Home', path: '/', component: Home },
    {
      name: 'payment',
      path: '/paying/:plan/:name/9d127bdb-429d-4850-89e3-b4655adebeeb',
      component: Paying,
      props: (route) => ({
        plan: route.params.plan,
        name: route.params.name,
      }),
    },
    {
      name: 'get-your-app',
      path: '/get-your-app/:id/',
      component: GetYourApp,
      props: (route) => ({
        id: route.params.id,
      }),
    },
    {
      name: 'get-your-app-commit',
      path: '/get-your-app-now/:id/',
      component: GetYourAppNow,
      props: (route) => ({
        id: route.params.id,
      }),
    },
    { name: 'quiz', path: '/apply-to-spiritt/:url', component: Quiz, props: (route) => ({
        url: route.params.url,
        industry: route.query ? route.query.industry : null,
        app_id: route.query ? route.query.app_id : null,
        business_id: route.query ? route.query.business_id : null,
        email: route.query ? route.query.email : null,
        firstname: route.query ? route.query.firstname : null
      }),
    },
    { name: 'create-app', path: '/create-app', component: Bot, props: (route) => ({
        url: route.params.url,
        email: route.query ? route.query.email : null,
        firstname: route.query ? route.query.firstname : null
      }),
    },
    { name: 'make-a-request', path: '/make-a-request', component: RequestBot, props: (route) => ({
        url: route.params.url,
        email: route.query ? route.query.email : null,
        firstname: route.query ? route.query.firstname : null
      }),
    },
    {
      name: 'apply-a-job', path: '/join-the-team', component: ApplyToAJob,
    },

    {
      name: 'applied', path: '/ohoo!you-did-it', component: Applied,
    },
    {
      name: 'las-step', path: '/last-step', component: LastStep,
    },
    { name: 'deck', path: '/deck/:deck', component: Deck, props: (route) => ({
        deck: route.params.deck,
      }),
    },
    { name: 'pitch', path: '/pitch/:pitchid', component: Pitch, props: (route) => ({
        pitchid: route.params.pitchid,
      }),
    },
    {
      name: 'sxsw', path: '/sxsw', component: Sxsw,
    },
    {
      name: 'sxsw-register', path: '/sxsw-sydney', component: SxswRegister,
    },
  ],
});

export default router;
